var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoginBtnGoogleIcon = function SvgLoginBtnGoogleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "login-btn-google-icon_svg__a",
    width: 24,
    height: 24,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    fillRule: "evenodd",
    d: "M20.537 8C10.925 8 5.519 17.007 9.123 25.414c4.205 7.806 14.418 9.007 20.425 1.801 3.004-3.603 2.403-9.607 2.403-9.607H19.936v4.803H26.751c-1.98 5.772-10.181 6.487-12.878 1.398-1.568-2.035-1.668-7.018 1.266-9.242 5.118-3.878 9.301-.192 9.301-.192l3.412-3.438S24.28 8 20.537 8Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#login-btn-google-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EA4235",
    d: "M8.826 9.22 22.07-1.176l8.895 11.32-6.622 5.198-8.846 2.37-2.223-2.83-4.448-5.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4385F5",
    d: "m28.242 33.93 13.244-10.398-10.521-13.39-6.427 6.436H17.72v3.963l10.521 13.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FABC05",
    d: "m8.826 9.22-11.524 9.048 8.895 11.32 11.524-9.048z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "m28.523 34.287-11.524 9.048L6.197 29.588l11.524-9.048z"
  }))));
};
export default SvgLoginBtnGoogleIcon;